import { c as _c } from "react/compiler-runtime";
import { HOTEL_DETAILS_MODAL, ZIN_DISPLAY_KEY_STORY_TOUR_CITY_PAGE, ZIN_KEY } from "@website/accommodation-ui/constant";
import { convertStringToDatePickerValue, getPassengersAndRoomFromQuery } from "@website/accommodation-ui/helpers";
import { HotelCitiesMainContent } from "@website/accommodation-ui/hotel-cities-main-content";
import { HotelShortVideos } from "@website/accommodation-ui/hotel-short-videos";
import { PriceCalendarWrapper } from "@website/accommodation-ui/price-calendar-wrapper/price-calendar-wrapper";
import { TourCardHotelFurthermore } from "@website/accommodation-ui/tour-card/tour-card-hotel/tour-card-hotel-furthermore";
import { TourEmptyState } from "@website/accommodation-ui/tour-empty-state";
import { TourLayout } from "@website/accommodation-ui/tour-layout";
import { TourReminder } from "@website/accommodation-ui/tour-reminder";
import { TourResultHeader } from "@website/accommodation-ui/tour-result-header";
import { TourResultMessages } from "@website/accommodation-ui/tour-result-messages";
import { TourSearchBox } from "@website/accommodation-ui/tour-search-box";
import { getTracking } from "@website/store/tracking";
import { getOrigin } from "@website/utils/channel/get-origin";
import { isChannel } from "@website/utils/channel/helpers";
import { getFormattedFutureDate, isInvalidCheckin, tomorrow } from "@website/utils/date-format";
import { numberConvert } from "@website/utils/number-convert";
import { Pagination } from "@website/utils/pagination/pagination";
import { BannerSlide } from "@website/widget/banner-slide";
import { Filters, useCityFilterState, useFilters } from "@website/widget/filter";
import { Telesales } from "@website/widget/telesales";
import isEmpty from "lodash-es/isEmpty";
import omit from "lodash-es/omit";
import { NextPage } from "next";
import Head from "next/head";
import { useRouter } from "next/router";
import { FC, useEffect } from "react";
import { useTelesales } from "../../../hooks/telesales";
import Custom404 from "../../[...gone].page";
import { useEmptyStates } from "./empty.hook";
import { usePageEvents } from "./events.hooks";
import { useSolutionsFilters } from "./filters.hook";
import { useTransformToHotels } from "./hotels.hook";
import { useInstalmentWallet } from "./instalment.hook";
import { PageBreadcrumb } from "./page.breadcrumb";
import { useSolutions } from "./solution.hook";
import { sorts } from "./sorts.constant";
import TourResults from "./tour-results";
import { ResultPagePropertiesType } from "./types";
const TourResultPageContent: FC<ResultPagePropertiesType> = properties => {
  const $ = _c(111);
  const {
    destData,
    originData,
    banners,
    originSuggestions,
    destinationSuggestions,
    ssrResults,
    isSEOPage
  } = properties;
  const {
    title_fa: cityFromTitle,
    iata_code: cityFromCode
  } = originData || {};
  const {
    title_fa: cityToTitle,
    iata_code: cityToCode
  } = destData || {};
  const {
    query,
    replace
  } = useRouter();
  const shouldUseSsrResults = isEmpty(omit(query, ["origin", "dest"]));
  const {
    stDate: stDateParameter,
    rtDate: rtDateParameter,
    passengers: t0,
    origin,
    dest,
    search_source,
    source,
    calendar_type,
    hotel_name,
    stars,
    rate,
    facilities,
    price_from,
    price_to,
    order_by,
    transport_types
  } = query as Record<string, string>;
  const passengersParameter = t0 === undefined ? "2" : t0;
  const canonicalUrl = `${process.env.NEXT_PUBLIC_BASE_URL_B2C}${process.env.NEXT_PUBLIC_BASE_PATHNAME}/${origin}/${dest}`;
  const stDate = stDateParameter || getFormattedFutureDate(3);
  const rtDate = rtDateParameter || getFormattedFutureDate(5);
  const experimentNewDesign = getTracking()?.experiment?.experiment_new_tour_design === "true";
  const {
    passengers,
    rooms,
    adults: adultsCount,
    child: childCount
  } = getPassengersAndRoomFromQuery(passengersParameter);
  const {
    totalSolutionsCount,
    solutions,
    availableFilters,
    remainSolutionsCount,
    onNextPage,
    isLoading,
    isError
  } = useSolutions({
    ssrResults: shouldUseSsrResults ? ssrResults : null,
    origin,
    dest,
    rtDate,
    stDate,
    passengers,
    passengersParameter,
    filterParameters: {
      order_by,
      hotel_name,
      stars,
      rate,
      facilities,
      price_from,
      price_to,
      transport_types
    }
  });
  const {
    filtersSchema
  } = useSolutionsFilters({
    stDate,
    rtDate,
    roomCount: rooms.length,
    availableFilters
  });
  const {
    installmentWallet
  } = useInstalmentWallet();
  const {
    emptyStates
  } = useEmptyStates({
    origin,
    dest,
    rtDate,
    stDate,
    passengers
  });
  const {
    onOpenFilters
  } = useCityFilterState();
  let t1;
  if ($[0] !== filtersSchema) {
    t1 = {
      schema: filtersSchema
    };
    $[0] = filtersSchema;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    selectedFiltersCount,
    clearFilters,
    filterKeys
  } = useFilters(t1);
  let t2;
  if ($[2] !== filterKeys || $[3] !== query) {
    t2 = omit(query, filterKeys);
    $[2] = filterKeys;
    $[3] = query;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const baseQueryParameters = t2;
  const hasFilter = Boolean(selectedFiltersCount);
  const {
    hotelList
  } = useTransformToHotels({
    solutions,
    cityFromTitle,
    cityToTitle,
    hasFilter,
    adultsCount,
    childCount,
    rooms,
    passengers,
    params: {
      dest,
      search_source,
      source,
      stDate,
      rtDate,
      calendar_type,
      passengersParameter
    }
  });
  usePageEvents({
    isLoading,
    solutionsLength: solutions.length,
    dest,
    stDate,
    rtDate,
    source,
    search_source,
    roomsLength: rooms.length,
    calendar_type,
    totalCount: totalSolutionsCount,
    hasFilter,
    number_of_passengers: adultsCount + childCount
  });
  const t3 = `${dest},${origin}/${dest}`;
  let t4;
  if ($[5] !== t3) {
    t4 = t3.replaceAll(" ", "_");
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const zinStoryTag = t4;
  const {
    teleSalesData
  } = useTelesales();
  let t5;
  if ($[7] !== query || $[8] !== solutions) {
    let t6;
    if ($[10] !== query) {
      t6 = sl => sl.hotel.id === Number(query[HOTEL_DETAILS_MODAL] || -1);
      $[10] = query;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    t5 = solutions.find(t6);
    $[7] = query;
    $[8] = solutions;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const selectedSolution = t5;
  const webengageData = {
    OriginCity: cityFromTitle,
    DestinationCity: cityToTitle,
    DepartureDate: stDate,
    ReturningDate: rtDate,
    AdultCount: `${adultsCount}`,
    ChildCount: `${childCount}`,
    ChildAge: passengers?.flatMap(_temp)?.join("-"),
    RoomCount: `${rooms?.length}`
  };
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = new Date(tomorrow());
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const stDateIsGreaterThanTomorrow = new Date(stDate) > t6;
  const tourPageTitle = `قیمت تور ${cityToTitle} از ${cityFromTitle} - آفر تور لحظه آخری ${cityToTitle} + لیست هتل‌ها`;
  const tourPageDescription = `لیست تورهای ${cityToTitle} از ${cityFromTitle} همراه با قیمت به‌روز، معرفی هتل‌ها، تاریخ حرکت و امکان رزرو آنلاین. بهترین پکیج‌های تور ${cityToTitle} را مقایسه و انتخاب کنید.`;
  useEffect(() => {
    if (isInvalidCheckin(stDate, rtDate)) {
      replace({
        pathname: "/[origin]/[dest]",
        query: {
          origin,
          dest
        }
      }, undefined, {
        shallow: true,
        scroll: false
      });
    }
  }, [stDate, rtDate]);
  let t7;
  if ($[13] !== tourPageTitle) {
    t7 = <title>{tourPageTitle}</title>;
    $[13] = tourPageTitle;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== tourPageDescription) {
    t8 = <meta name="description" content={tourPageDescription} />;
    $[15] = tourPageDescription;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== canonicalUrl) {
    t9 = <link href={canonicalUrl} rel="canonical" />;
    $[17] = canonicalUrl;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t7 || $[20] !== t8 || $[21] !== t9) {
    t10 = <Head>{t7}{t8}{t9}</Head>;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== stDateParameter) {
    t11 = stDateParameter ? new Date(stDateParameter).toLocaleDateString("fa-IR", {
      day: "2-digit",
      month: "long"
    }) : "";
    $[23] = stDateParameter;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== rtDateParameter) {
    t12 = rtDateParameter ? new Date(rtDateParameter).toLocaleDateString("fa-IR", {
      day: "2-digit",
      month: "long"
    }) : "";
    $[25] = rtDateParameter;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== adultsCount) {
    t13 = numberConvert(adultsCount, {
      locale: "fa"
    });
    $[27] = adultsCount;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== childCount) {
    t14 = childCount ? ` و ${numberConvert(childCount, {
      locale: "fa"
    })} کودک` : "";
    $[29] = childCount;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  const t15 = `${t13} بزرگسال
          ${t14} `;
  const t16 = `${numberConvert(rooms?.length, {
    locale: "fa"
  })} اتاق`;
  let t17;
  if ($[31] !== t15 || $[32] !== t16) {
    t17 = [t15, t16];
    $[31] = t15;
    $[32] = t16;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  const t18 = `  تور ${cityFromTitle} به ${cityToTitle}`;
  let t19;
  if ($[34] !== isSEOPage || $[35] !== t11 || $[36] !== t12 || $[37] !== t17 || $[38] !== t18) {
    t19 = {
      dateFrom: t11,
      dateTo: t12,
      detail: t17,
      title: t18,
      isHeadingSpan: isSEOPage
    };
    $[34] = isSEOPage;
    $[35] = t11;
    $[36] = t12;
    $[37] = t17;
    $[38] = t18;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] !== stDateParameter) {
    t20 = convertStringToDatePickerValue(stDateParameter);
    $[40] = stDateParameter;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  let t21;
  if ($[42] !== rtDateParameter) {
    t21 = convertStringToDatePickerValue(rtDateParameter);
    $[42] = rtDateParameter;
    $[43] = t21;
  } else {
    t21 = $[43];
  }
  let t22;
  if ($[44] !== t20 || $[45] !== t21) {
    t22 = [t20, t21];
    $[44] = t20;
    $[45] = t21;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  const t23 = `تور ${cityFromTitle} به ${cityToTitle}`;
  let t24;
  if ($[47] !== t23) {
    t24 = <PageBreadcrumb tourFromToDestDesc={t23} />;
    $[47] = t23;
    $[48] = t24;
  } else {
    t24 = $[48];
  }
  let t25;
  if ($[49] !== banners.sidebarBanner) {
    t25 = Boolean(banners.sidebarBanner?.length) && <div className="mb-4 hidden h-[144px] w-full max-w-[312px] xl:block"><BannerSlide className="p-0" list={banners.sidebarBanner} /></div>;
    $[49] = banners.sidebarBanner;
    $[50] = t25;
  } else {
    t25 = $[50];
  }
  let t26;
  if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = {
      size: "small",
      color: "secondary",
      variant: "text"
    };
    $[51] = t26;
  } else {
    t26 = $[51];
  }
  const t27 = totalSolutionsCount ?? 0;
  let t28;
  if ($[52] !== t27) {
    t28 = numberConvert(t27, {
      locale: "fa"
    });
    $[52] = t27;
    $[53] = t28;
  } else {
    t28 = $[53];
  }
  const t29 = `نمایش ${t28} نتیجه`;
  let t30;
  if ($[54] !== filtersSchema || $[55] !== isLoading || $[56] !== t29) {
    t30 = <div className="grow lg:first:[&>aside>div]:top-20"><Filters resetButtonProps={t26} schema={filtersSchema} title={"\u0641\u06CC\u0644\u062A\u0631\u0647\u0627"} scroll={true} loading={isLoading} filtersActionTitle={t29} filtersClassName="xl:!max-h-[calc(100vh-88px)]" /></div>;
    $[54] = filtersSchema;
    $[55] = isLoading;
    $[56] = t29;
    $[57] = t30;
  } else {
    t30 = $[57];
  }
  let t31;
  if ($[58] !== t25 || $[59] !== t30) {
    t31 = <div className="flex flex-col">{t25}{t30}</div>;
    $[58] = t25;
    $[59] = t30;
    $[60] = t31;
  } else {
    t31 = $[60];
  }
  let t32;
  if ($[61] !== cityFromTitle || $[62] !== cityToTitle || $[63] !== isSEOPage) {
    t32 = isSEOPage && <h1 className="text-headline-6 max-sm:text-subtitle-1 order-2 lg:order-1">{`تور ${cityToTitle} از ${cityFromTitle}`}</h1>;
    $[61] = cityFromTitle;
    $[62] = cityToTitle;
    $[63] = isSEOPage;
    $[64] = t32;
  } else {
    t32 = $[64];
  }
  let t33;
  if ($[65] !== cityFromTitle || $[66] !== cityToTitle || $[67] !== dest || $[68] !== origin || $[69] !== passengers || $[70] !== rtDate || $[71] !== stDate || $[72] !== totalSolutionsCount) {
    t33 = <div className="order-3 lg:order-2"><PriceCalendarWrapper solutionCount={totalSolutionsCount} stDate={stDate} rtDate={rtDate} cityFromTitle={cityFromTitle} cityToTitle={cityToTitle} origin={origin} dest={dest} passengers={passengers} /></div>;
    $[65] = cityFromTitle;
    $[66] = cityToTitle;
    $[67] = dest;
    $[68] = origin;
    $[69] = passengers;
    $[70] = rtDate;
    $[71] = stDate;
    $[72] = totalSolutionsCount;
    $[73] = t33;
  } else {
    t33 = $[73];
  }
  let t34;
  if ($[74] !== cityFromTitle || $[75] !== cityToTitle || $[76] !== isLoading || $[77] !== solutions.length || $[78] !== totalSolutionsCount) {
    t34 = isLoading && solutions.length === 0 ? `در جستجوی تور‌های ${cityFromTitle} به ${cityToTitle} ...` : `${numberConvert(totalSolutionsCount, {
      locale: "fa"
    })} هتل برای تور  ${cityFromTitle} به ${cityToTitle}`;
    $[74] = cityFromTitle;
    $[75] = cityToTitle;
    $[76] = isLoading;
    $[77] = solutions.length;
    $[78] = totalSolutionsCount;
    $[79] = t34;
  } else {
    t34 = $[79];
  }
  let t35;
  if ($[80] !== onOpenFilters || $[81] !== selectedFiltersCount || $[82] !== t34) {
    t35 = <TourResultHeader setFilterOpen={onOpenFilters} selectedFiltersCount={selectedFiltersCount} sorts={sorts} desc={t34} />;
    $[80] = onOpenFilters;
    $[81] = selectedFiltersCount;
    $[82] = t34;
    $[83] = t35;
  } else {
    t35 = $[83];
  }
  let t36;
  if ($[84] !== zinStoryTag) {
    t36 = isChannel(["jek", "android"]) && <HotelShortVideos className="bg-on-color-high-emphasis border-y-outline-thin -mx-6 -mb-5 !h-auto border px-4 lg:m-0 lg:hidden" displayType="STORY" displayId={ZIN_DISPLAY_KEY_STORY_TOUR_CITY_PAGE} zinKey={ZIN_KEY} zinTags={zinStoryTag} />;
    $[84] = zinStoryTag;
    $[85] = t36;
  } else {
    t36 = $[85];
  }
  let t37;
  if ($[86] !== t36) {
    t37 = <div className="lg:first:[&>div]:mx-0">{t36}</div>;
    $[86] = t36;
    $[87] = t37;
  } else {
    t37 = $[87];
  }
  let t38;
  if ($[88] !== t35 || $[89] !== t37) {
    t38 = <div className="order-1 lg:order-2">{t35}{t37}</div>;
    $[88] = t35;
    $[89] = t37;
    $[90] = t38;
  } else {
    t38 = $[90];
  }
  let t39;
  if ($[91] !== t32 || $[92] !== t33 || $[93] !== t38) {
    t39 = <div className="flex flex-col gap-4 lg:gap-4">{t32}{t33}{t38}</div>;
    $[91] = t32;
    $[92] = t33;
    $[93] = t38;
    $[94] = t39;
  } else {
    t39 = $[94];
  }
  let t40;
  if ($[95] !== cityFromTitle || $[96] !== cityToTitle || $[97] !== isLoading || $[98] !== solutions.length || $[99] !== totalSolutionsCount) {
    t40 = !experimentNewDesign && <h2 className="text-on-surface-high-emphasis text-body-2 min-w-fit flex-1 md:hidden">{isLoading && solutions.length === 0 ? `در جستجوی تور‌های ${cityFromTitle} به ${cityToTitle} ...` : `${numberConvert(totalSolutionsCount, {
        locale: "fa"
      })} تور ${cityFromTitle} به ${cityToTitle}`}</h2>;
    $[95] = cityFromTitle;
    $[96] = cityToTitle;
    $[97] = isLoading;
    $[98] = solutions.length;
    $[99] = totalSolutionsCount;
    $[100] = t40;
  } else {
    t40 = $[100];
  }
  const t41 = !isLoading && solutions.length === 0 ? <><TourResultMessages destination={cityToTitle} origin={cityFromTitle} type={isError ? "ERROR" : hasFilter ? "NOTFOUND_FILTER" : "NOTFOUND"} link={isError ? `${getOrigin()}/tour` : {
      query: baseQueryParameters
    }} />{!isError && !hasFilter && <>{stDateIsGreaterThanTomorrow && <TourReminder dest={dest} origin={origin} stDate={stDate} rtDate={rtDate} />}<TourEmptyState data={emptyStates} cityToTitle={cityToTitle} cityFromTitle={cityFromTitle} /></>}</> : <Pagination remainsCount={remainSolutionsCount} onNextPage={onNextPage} isLoading={isLoading}>{experimentNewDesign ? <HotelCitiesMainContent size="responsive" cityTitle={`${cityFromTitle} به ${cityToTitle}`} clearAllFilters={clearFilters} hasError={false} noFollow={true} hasFilters={hasFilter} selectedHotelId={-1} hotelList={hotelList} hotelsSuggested={[]} loading={isLoading} totalItem={totalSolutionsCount} snappPayData={installmentWallet} bannerSlideList={banners.midPageBanner || []} setIsSearchPanelOpen={_temp4} /> : <TourResults solutions={solutions} isLoading={isLoading} noFollow={true} webengageData={webengageData} installmentWallet={installmentWallet} midPageBanner={banners.midPageBanner} />}</Pagination>;
  let t42;
  if ($[101] !== t39 || $[102] !== t40 || $[103] !== t41) {
    t42 = <div className="flex w-full flex-col gap-6 pb-8 xl:w-[calc(100%-336px)]">{t39}{t40}{t41}</div>;
    $[101] = t39;
    $[102] = t40;
    $[103] = t41;
    $[104] = t42;
  } else {
    t42 = $[104];
  }
  let t43;
  if ($[105] !== teleSalesData) {
    t43 = <Telesales {...teleSalesData} />;
    $[105] = teleSalesData;
    $[106] = t43;
  } else {
    t43 = $[106];
  }
  let t44;
  if ($[107] !== t31 || $[108] !== t42 || $[109] !== t43) {
    t44 = <section className="border-outline-thin flex px-6 pb-8 max-lg:border-t xl:mx-auto xl:w-[1200px] xl:px-0">{t31}{t42}{t43}</section>;
    $[107] = t31;
    $[108] = t42;
    $[109] = t43;
    $[110] = t44;
  } else {
    t44 = $[110];
  }
  return <>{t10}<TourLayout><TourSearchBox searchSummaryProperties={t19} searchPanelProperties={{
        cityFrom: {
          iata_code: cityFromCode,
          title: cityFromTitle,
          title_fa: cityFromTitle
        },
        cityTo: {
          iata_code: cityToCode,
          title: cityToTitle,
          title_fa: cityToTitle
        },
        dateRange: t22,
        passengers: passengers.map(_temp3),
        originSuggestions,
        destinationSuggestions
      }} />{t24}{t44}{Boolean(selectedSolution) && <TourCardHotelFurthermore {...selectedSolution} webengageData={webengageData} />}</TourLayout></>;
};
const Index: NextPage<ResultPagePropertiesType> = properties => {
  const $ = _c(3);
  if (!properties?.originData?.id || !properties?.destData?.id) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <Custom404 />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  if ($[1] !== properties) {
    t0 = <TourResultPageContent {...properties} />;
    $[1] = properties;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};
export default Index;
export { getServerSideProps } from "./index.server";
function _temp(room) {
  return room?.children;
}
function _temp2() {
  return 1;
}
function _temp3(item) {
  return {
    adult: Array.from({
      length: item.adultCount
    }).map(_temp2),
    child: item.children
  };
}
function _temp4() {}